<script>
export default {
    name: "ComponentTableCheckboxMixin",
    data() {
        return {
            allChecked: false,
            indeterminate: false,
        }
    },
    watch: {
        mappedItems: {
            deep: true,
            handler: function () {
                const checked = this.mappedItems.filter(e => e.checked);
                if (checked.length === this.mappedItems.length) {
                    this.indeterminate = false;
                    this.allChecked = true;
                } else if (checked.length < this.mappedItems.length && checked.length > 0) {
                    this.indeterminate = true;
                    this.allChecked = false;
                } else {
                    this.indeterminate = false;
                    this.allChecked = false;
                }
            }
        },

        allChecked(newValue) {
            if (this.indeterminate) {
                this.mappedItems.forEach(e => e.checked = true);
            } else if (newValue) {
                this.mappedItems.forEach(e => e.checked = true);
            } else {
                this.mappedItems.forEach(e => e.checked = false);
            }
        },

        checkedItems() {
            this.$emit("update:checked", this.checkedItems.map(e => e.raw));
        },
    },
    computed: {
        checkedItems() {
            return this.mappedItems.filter(e => e.checked);
        },
    },

}
</script>